import { API_GATEWAY_ENDPOINT } from "../constants/api";

export const getVueltasDia = async (id,fecha,controller) => {
  try{
    var myHeaders = new Headers();
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id_area_operacion:id,
      fecha:fecha
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
      signal: controller.signal
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"dashboard/get-vueltas-dia",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const getVueltasDiaByTipoMaquina = async (id,fecha,controller, id_tipo_maquina) => {
  try{
    var myHeaders = new Headers();
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id_area_operacion:id,
      fecha,
      id_tipo_maquina
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
      signal: controller.signal
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"dashboard/get-vueltas-dia-tipo-maquina",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const getMovimientosDia = async (id,fecha,controller) => {
  try{
    var myHeaders = new Headers();
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id_area_operacion:id,
      fecha:fecha
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
      signal: controller.signal
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"dashboard/get-movimientos-dia",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const getMovimientosDiaByTipoMaquina = async (id,fecha,controller,id_tipo_maquina) => {
  try{
    var myHeaders = new Headers();
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id_area_operacion:id,
      fecha:fecha,
      id_tipo_maquina
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
      signal: controller.signal
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"dashboard/get-movimientos-dia-tipo-maquina",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const getInfoGeneralMina = async (id,fecha, controller) => {
  try{
    var myHeaders = new Headers();
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id_area_operacion:id,
      fecha:fecha
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      signal: controller.signal
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"dashboard/get-info-general-mina",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const getReporteResumen = async (id,fechaInicio, fechaFin) => {
  try{
    var myHeaders = new Headers();
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id_area_operacion: id,
      fecha_inicial:fechaInicio,
      fecha_final: fechaFin
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"produccion/resumen",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const getJumboResumen = async (id,fechaInicio, fechaFin) => {
  try{
    var myHeaders = new Headers();
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id_area_operacion: id,
      fecha_inicial:fechaInicio,
      fecha_final: fechaFin
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    const res = await fetch(
        API_GATEWAY_ENDPOINT+"jumbo/export",
        requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  }
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const getReporteVueltas = async (id,fechaInicio, fechaFin) => {
  try{
    var myHeaders = new Headers();
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id_area_operacion: id,
      fecha_inicial:fechaInicio,
      fecha_final: fechaFin
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"produccion/vueltas",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const getInfoJumbo = async (idAreaOperacion,idMaquina,fecha,controller) => {
  try{
    var myHeaders = new Headers();
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id_area_operacion:idAreaOperacion,
      id_maquina:idMaquina, 
      fecha:fecha
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
      signal: controller.signal
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"maquina/get-info-jumbo",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const getAllJumbosByAreaOperacion = async (idAreaOperacion) => {
  try{
    var myHeaders = new Headers();
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id_area_operacion:idAreaOperacion
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"jumbo/get-by-mina",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const getAllBoltersByAreaOperacion = async (idAreaOperacion) => {
  try{
    var myHeaders = new Headers();
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id_area_operacion:idAreaOperacion
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"bolters/get-by-mina",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const getMetasEquiposByAreaOp = async (idAreaOperacion) => {
  try{
    var myHeaders = new Headers();
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id_area_operacion:idAreaOperacion
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"meta/mensual",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const getMovimientosGPS = async (id_area_operacion= 1, id_maquina = 560, fecha ="2023-11-02") => {
//export const getMovimientosGPS = async (id_area_operacion= 1, id_maquina = 3, fecha ="2023-10-31") => {  
try{
    var myHeaders = new Headers();
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id_area_operacion,
      id_maquina,
      fecha
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"maquina/get-movimientos-gps",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const getGeoCercasGPS = async (id_area_operacion, controla_velocidad) => {
  try{
    var myHeaders = new Headers();
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id_area_operacion,
      controla_velocidad
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"geocerca",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const getEncuentroGPS = async (id_area_operacion, id_maquina, fecha) => {
  try{
    var myHeaders = new Headers();
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id_area_operacion,
      id_maquina,
      fecha
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"maquina/get-encuentro-gps",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const getInformacionVueltasGPS = async (id_maquina, fecha) => {
  try{
    var myHeaders = new Headers();
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id_maquina,
      fecha_dia:fecha
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"maquina/vueltas_gps",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}


export const getHora_ingreso_egreso = async (id_area_operacion, fecha,id_tipo_maquina, id_maquina) => {
  try{
    var myHeaders = new Headers();
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id_area_operacion,
      fecha,
      id_tipo_maquina,
      id_maquina
    });

    var requestOptions = {
      method: 'POST',
      body: raw,
      redirect: 'follow',
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"area-operacion/hora_ingreso_egreso",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}


export const descargarControlVelocidad = async (id_area_operacion, fecha_inicio, fecha_termino) => {

  try{
    
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);

    var raw = JSON.stringify({
      id_area_operacion,
      fecha_inicio,
      fecha_termino
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    const res = await fetch(
    
      API_GATEWAY_ENDPOINT+"gps/descargar-exceso-velocidad",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const descargarVueltasGps = async (id_area_operacion, fecha_inicio, fecha_termino) => {

  try{
    
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);

    var raw = JSON.stringify({
      id_area_operacion,
      fecha_inicio,
      fecha_termino
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"gps/descargar-vueltas",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const getCargasTipoMaquina = async (id_area_operacion, fecha) => {

  try{
    
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);

    var raw = JSON.stringify({
      id_area_operacion,
      fecha
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"dashboard/get-cargas-dia-tipo-maquina",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const getCargasByIdMaquina = async (id_area_operacion, fecha,id_maquina) => {

  try{
    
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);

    var raw = JSON.stringify({
      id_area_operacion,
      fecha,
      id_maquina
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"maquina/get-cargas",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const getBaldadasByIdMaquina = async (id_area_operacion, id_maquina, dia) => {

  try{
    
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);

    var raw = JSON.stringify({
      id_area_operacion,
      id_maquina,
      dia
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"maquina/get-baldadas",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const descargarResumenTurnos = async (id_area_operacion, fecha_inicio, fecha_termino) => {

  try{
    
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);

    var raw = JSON.stringify({
      id_area_operacion,
      fecha_inicio,
      fecha_termino
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    const res = await fetch(
    
      API_GATEWAY_ENDPOINT+"dashboard/get-resumen-turno",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const descargarResumenTurnosPorGrupoBeacon = async (id_area_operacion, fecha_inicio, fecha_termino) => {

  try{
    
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);

    var raw = JSON.stringify({
      id_area_operacion,
      fecha_inicio,
      fecha_termino
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    const res = await fetch(
    
      API_GATEWAY_ENDPOINT+"dashboard/get-resumen-turno-por-grupo-beacon",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export const descargarResumenMantenciones = async (id, fechaInicio, fechaFin) => {
  try{
    var myHeaders = new Headers();
    myHeaders.append("x-api-key", `${process.env.REACT_APP_API_KEY}`);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id_area_operacion: id,
      fecha_inicial:fechaInicio,
      fecha_final: fechaFin
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    const res = await fetch(
      API_GATEWAY_ENDPOINT+"produccion/mantenciones",
      requestOptions
    );

    if (!res.ok) throw new Error(res.text());
    const json = await res.json();
    return { success: true, data: json };
  } 
  catch (e) {
    console.error(e);
    return { success: false, data: [] };
  }
}

export async function descargarResumenTablets(idMina, fechaInicio, fechaFinal) {
  try {
    const response = await fetch(API_GATEWAY_ENDPOINT+"tablet/descargar-resumen-tablet", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": `${process.env.REACT_APP_API_KEY}`
      },
      body: JSON.stringify({
        idMina,
        fechaInicio,
        fechaFinal
      })
    })

    if (!response.ok) {
      return { success: false, data: [], error: response.text() };
    }

    const { jefesTurno, scoops, dumpers, horometros } = await response.json();

    return { success: true, data: { jefesTurno , scoops, dumpers, horometros }, error: null };
  } catch (e) {
    console.error(e);
    return { success: false, data: [], error: e.message };
  }
}

export async function getMovimientosMaquina(idMaquina, startDate, endDate) {
  try {
    const response = await fetch(
      `${API_GATEWAY_ENDPOINT}jumbo/get-movimientos-rango-fechas`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": `${process.env.REACT_APP_API_KEY}`
        },
        body: JSON.stringify({
          idMaquina: idMaquina,
          fechaInicio: startDate,
          fechaFinal: endDate
        })
      }
    );

    if (!response.ok) {
      return {
        status: "error",
        message: "Ha ocurrido un error al intentar obtener los datos",
        data: []
      }
    }

    const { data, message, status } = await response.json();

    return {
      status,
      message,
      data
    }
  } catch (error) {
    return {
      status: "error",
      data: [],
      error: "Ha ocurrido un error al intentar obtener los datos"
    }
  }
}